module.exports = __webpack_public_path__ + "img/braning-banner1.cc87e87f.jpg";